/**
 * Socle de traduction : un message = une entrée, les deux langues côte à côte.
 *
 * Le choix du côte à côte plutôt que d'un fichier par langue est volontaire :
 * une clé ajoutée sans sa traduction ne compile pas, et un relecteur voit la
 * paire sans ouvrir deux fichiers. Le typage de `Bundle` interdit d'oublier
 * l'anglais.
 */
export type Lang = 'fr' | 'en'

export const LANGS: Lang[] = ['fr', 'en']

/** Nom de la langue dans sa propre langue : un sélecteur ne doit jamais s'auto-traduire. */
export const LANG_NAMES: Record<Lang, string> = {
  fr: 'Français',
  en: 'English',
}

/** Étiquette courte du sélecteur rabattu. */
export const LANG_SHORT: Record<Lang, string> = {
  fr: 'FR',
  en: 'EN',
}

/** Étiquette BCP 47 passée à `Intl`. en-GB : jour/mois/année, comme en français. */
export const LANG_LOCALES: Record<Lang, string> = {
  fr: 'fr-FR',
  en: 'en-GB',
}

/**
 * Un message, dans une langue : une chaîne, ou le couple singulier / pluriel.
 *
 * Les deux langues ne coupent pas au même endroit : le français met le
 * singulier à zéro comme à un (« 0 test », « 1 test »), l'anglais le réserve à
 * un (« 0 tests », « 1 test »). La forme est donc choisie par langue, et non
 * par une règle unique.
 */
export type Plural = [one: string, other: string]

export interface Message {
  fr: string | Plural
  en: string | Plural
}

export type Bundle = Record<string, Message>

/** Forme à retenir pour `n`, selon la langue. */
export function pluralForm(lang: Lang, n: number): 0 | 1 {
  if (lang === 'fr') return Math.abs(n) < 2 ? 0 : 1
  return Math.abs(n) === 1 ? 0 : 1
}

/** Valeurs injectables dans un message, à la place de `{nom}`. */
export type Vars = Record<string, string | number>
